import {useState,useEffect} from 'react'
import { Tooltip } from '@mui/material';
import {  ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../../components/button';
import { toast } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import FranchiseRequestMenu from './FranchiseRequestMenu';
import {AiOutlineEdit,AiOutlineDelete} from 'react-icons/ai'
import { DatePicker, Modal, Select } from 'antd';
import moment from 'moment';
import { DeleteDigitalCardService, GetDigitalCardService } from '../../../services/admin/DigitalCardServices';
import { useSelector } from 'react-redux';
import { GetDigitalCardDistributorSearchService } from '../../../services/admin/DigitalCardDistributorServices';
import { GetFranchiseRequestService, DeleteFranchiseRequestService } from '../../../services/admin/FranchiseListServices';
import { franchiseCityList, franchiseStepsList } from './constant'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';

function FranchiseRequestList() {


    const roles = useSelector(state=>state.Auth.roles)
  
    const [data,setdata] = useState({pagination:{total:0},datas:[]})
    const [selecteddata,setselecteddata] = useState({})
    const [distributors,setdistributors] = useState([])
    const [modal, setModal] = useState(false);
    const navigate = useNavigate()
    const [page,setpage] = useState(1)

    const {pathname} = useLocation();
    const path = pathname.split('/')[1]

    const [step,setstep] = useState(franchiseStepsList[0])

    const [search, setsearch] = useState({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,distributor:'' })
    
  
    useEffect(()=>{
        getData(page)
    },[page, step])

    
    

  
  async function getData(page=1){
   const response = await GetFranchiseRequestService(page,step.value,search.text,search.from_date1,search.to_date1,search.city??'')
   setdata(response.data)
  }  

  async function deletedepartment(){
    const response = await DeleteFranchiseRequestService(selecteddata._id)
    if(response.status === 200){
        setModal(false)
        toast.success(response.data.datas)
        getData(page)
    }
  }

   async function searchData(val,type){
      
        if(type === 'distributor'){
          const response = await GetDigitalCardDistributorSearchService(val,1, '', '', '','All Data','',val)
          let arr = []
          response?.data?.datas?.forEach((d)=>{
            arr?.push({label:d?.name === '' ? ('No name added ' + d?.phone) : d?.name + ' ' + d?.phone,value:d?._id})
          })
          setdistributors(arr)
        }
      }

  async function applyFilter(){
    const response = await GetFranchiseRequestService(1,step.value,search.text,search.from_date1,search.to_date1,search.city??'')
    setdata(response.data)
  }

  async function resetfilter(){
     const response = await GetFranchiseRequestService(1,step.value,'','','','')
     setdata(response.data)
     setpage(1)
     setsearch({ text: '', text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,city:'' })
  }

  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
     <Modal
        keepMounted
        open={modal}
        onClose={()=>setModal(false)}
        width={300}
        footer={false}
        closable={false}
       
      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            {/* <div className='mr-1 w-full'> */}
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setModal(false)} />
            {/* </div> */}
            <div  className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Confirm'} onClick={()=>deletedepartment()}  /> 
            </div>
          </div>
        </div>
      </Modal>
        
      <div className='block sm:flex'>
         {path === 'franchise_request'  ? <FranchiseRequestMenu /> : <SettingsMenu />}

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex flex-wrap justify-between align-center items-center border-b pb-2 ">
        <span className="font-[800] text-[14px]">Franchise Request ({data?.pagination?.total})</span>
 
        <div className='flex flex-wrap items-center'>

             <div className='flex items-center  text-[12px] mr-2'>

              <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
              <IconButton onClick={resetfilter}><BsArrowRepeat size={16} /></IconButton>

              <div>
              <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
              <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

              </div>
              </div>

          <div className='mr-2 mt-1 md:mt-0'>
            <input id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] focus:ring-0 focus:outline-0 text-[14px]  w-[100px] px-1 rounded-md border-slate-300' />
          </div>

          <DatePicker size='small' style={{ fontSize: '11px' }} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

          <DatePicker size='small' style={{ fontSize: '11px' }} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

        {roles?.includes('admin') &&
          <div className='mr-2 w-[130px]'>
            <Select 
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              value={search?.city == '' ? null : search?.city}
              bordered={false}
              className='border rounded h-[29px] border-slate-300 w-[100%] place-holder:text-[10px]'
              options={franchiseCityList}
              placeholder={<span className="text-[12px] text-gray-300 ">Select City</span>}
              onChange={(e)=>setsearch({...search,city:e})}
              />
          </div>}

           <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

        {roles?.includes('admin') &&
         <ButtonFilledAutoWidth  btnName="Add Franchise Request" onClick={()=>navigate('create')} /> 
        }
        </div>


        </div>
        </div>

         <div className='flex mb-2 items-center border-y overflow-x-auto flex-nowrap'>
          {franchiseStepsList?.map((s)=>(
          <h6 onClick={()=>{setstep(s);setpage(1)}} className={`font-[600] ${step?.value === s.value && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s.label}</h6>
          ))}
        </div>


        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }

      


        {data?.datas?.length > 0 &&
        <>
        {/* Desktop / tablet table */}
        <div className='hidden md:block md:max-h-[82vh] mt-2 md:overflow-auto border-t border-l border-r'>
          <div className='sticky top-0 z-50 flex w-full bg-white border-b border-slate-200'>
            <h6 className='text-[12px] min-w-[50px] w-[50px] px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
            <h6 className='text-[12px] min-w-[120px] w-[120px] px-2 py-1 font-[600] text-slate-800 border-r'>Name</h6>
            <h6 className='text-[12px] min-w-[120px] w-[120px] px-2 py-1 font-[600] text-slate-800 border-r'>Mobile</h6>
            <h6 className='text-[12px] min-w-[200px] w-[200px] px-2 py-1 font-[600] text-slate-800 border-r'>City</h6>
            <h6 className='text-[12px] min-w-[200px] w-[200px] px-2 py-1 font-[600] text-slate-800 border-r'>Remarks</h6>
            <h6 className='text-[12px] min-w-[100px] w-[100px] px-2 py-1 font-[600] text-slate-800 border-r'>Status</h6>
            <h6 className='text-[12px] min-w-[170px] w-[170px] px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
            {roles?.includes('admin') && <h6 className='text-[12px] min-w-[80px] w-[80px] px-2 py-1 font-[600] text-slate-800'>Actions</h6>}
          </div>
          {data?.datas?.map((d,i)=>(
          <div key={d?.id} className='flex w-full border-b border-slate-200'>
            <h6 className='text-[12px] min-w-[50px] w-[50px] px-2 py-1 font-[500] border-r flex items-center justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>
            <h6 className='text-[11px] min-w-[120px] w-[120px] px-2 py-1 font-[500] border-r break-words'>{d?.name || '-'}</h6>
            <h6 className='text-[11px] min-w-[120px] w-[120px] px-2 py-1 font-[500] border-r'>{d?.mobile || '-'}</h6>
            <h6 className='text-[11px] min-w-[200px] w-[200px] px-2 py-1 font-[500] border-r break-words'>{d?.city || 'No city added'}</h6>
            <h6 className='text-[11px] min-w-[200px] w-[200px] px-2 py-1 font-[500] border-r break-words'>{d?.remarks || 'No remarks added'}</h6>
            <h6 className='text-[11px] min-w-[100px] w-[100px] px-2 py-1 border-r flex items-center'>
              <span className={`${d?.used ? 'bg-green-200' : 'bg-blue-200'} px-2 py-0.5 rounded text-[10px] font-[600]`}>{franchiseStepsList.find(step => step.value === d?.status)?.label || 'Unknown'}</span>
            </h6>
            <h6 className='text-[11px] min-w-[170px] w-[170px] px-2 py-1 font-[500] border-r'>{moment(d?.createdAt).format('LLL')}</h6>
            {roles?.includes('admin') &&
            <h6 className='text-[11px] min-w-[80px] w-[80px] px-2 py-1 font-[500] flex items-center'>
              <Tooltip title="Edit">
                <span><AiOutlineEdit size={14} className="cursor-pointer mr-2" onClick={()=>{navigate('edit',{state:d})}}/></span>
              </Tooltip>
              <Tooltip title="Delete">
                <span><AiOutlineDelete size={14} className='cursor-pointer' onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
              </Tooltip>
            </h6>}
          </div>
          ))}
        </div>

        {/* Mobile card list */}
        <div className='md:hidden mt-2 space-y-2'>
          {data?.datas?.map((d,i)=>(
            <div key={d?.id} className='border rounded-md p-3 bg-white'>
              <div className='flex items-start justify-between'>
                <div>
                  <h6 className='text-[13px] font-[700]'>{d?.name || '-'}</h6>
                  <h6 className='text-[11px] text-slate-600'>{d?.mobile || '-'}</h6>
                </div>
                {roles?.includes('admin') &&
                <div className='flex items-center -mr-1.5'>
                  <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={()=>{navigate('edit',{state:d})}}/></span>
                  <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={()=>{setselecteddata(d);setModal(true)}}/></span>
                </div>}
              </div>

              <span className={`${d?.used ? 'bg-green-200' : 'bg-blue-200'} inline-block px-2 py-0.5 rounded text-[10px] font-[600] mt-1.5`}>{franchiseStepsList.find(step => step.value === d?.status)?.label || 'Unknown'}</span>

              <h6 className='text-[11px] mt-2'><span className='font-[600]'>City:</span> {d?.city || 'No city added'}</h6>
              <h6 className='text-[11px] mt-1'><span className='font-[600]'>Remarks:</span> {d?.remarks || 'No remarks added'}</h6>

              <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt).format('LLL')}</h6>
            </div>
          ))}
        </div>
        </>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default FranchiseRequestList